<script>
export default {
	name: 'AquaObjectInput',
	props: {
		modelValue: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: () => [],
		},
		title: {
			type: String,
			default: '',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			opened: false,
		}
	},
	computed: {
		suggestions() {
			const query = (this.modelValue || '').trim().toLowerCase()
			const exact = this.options.some((option) => option.toLowerCase() === query)
			if (!query || exact) return this.options
			return this.options.filter((option) => option.toLowerCase().includes(query))
		},
	},
	methods: {
		choose(option) {
			this.$emit('update:modelValue', option)
			this.opened = false
		},
		close() {
			setTimeout(() => {
				this.opened = false
			}, 150)
		},
	},
}
</script>

<template>
	<div class="aqua-object">
		<div v-if="title" class="title">{{ title }}</div>
		<div class="aqua-object__field">
			<input
				class="aq-input aqua-object__input"
				type="text"
				:value="modelValue"
				:disabled="disabled"
				:placeholder="options.length ? $t('aqua.object.placeholder') : ''"
				@input="$emit('update:modelValue', $event.target.value)"
				@focus="opened = true"
				@blur="close"
			/>
			<span v-if="options.length && !disabled" class="aqua-object__caret" @mousedown.prevent="opened = !opened"></span>
			<ul v-if="opened && suggestions.length && !disabled" class="aqua-object__list">
				<li v-for="option in suggestions" :key="option" @mousedown.prevent="choose(option)">{{ option }}</li>
			</ul>
		</div>
	</div>
</template>

<style scoped>
.aqua-object__field {
	position: relative;
}
.aqua-object__input {
	width: 100%;
	padding-right: 36px;
}
.aqua-object__caret {
	position: absolute;
	top: 0;
	right: 0;
	width: 36px;
	height: 100%;
	cursor: pointer;
	background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0h10L5 6z' fill='%230a091d'/%3E%3C/svg%3E")
		no-repeat center;
}
.aqua-object__list {
	position: absolute;
	z-index: 20;
	top: calc(100% + 4px);
	left: 0;
	right: 0;
	max-height: 220px;
	margin: 0;
	padding: 4px 0;
	overflow-y: auto;
	list-style: none;
	border: 1px solid #d3e7fb;
	border-radius: 8px;
	background: #fff;
	box-shadow: 0 8px 24px rgba(21, 29, 72, 0.12);
}
.aqua-object__list li {
	padding: 8px 12px;
	cursor: pointer;
	font-size: 14px;
}
.aqua-object__list li:hover {
	background: #eaf3fd;
	color: #157fee;
}
</style>
